import { api } from "constants/RotasAPI";
import usePut from "hooks/usePut";
import toast from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ProcessosJudiciaisDTO } from "types/dto/ProcessosJudiciaisDTO";

export const usePutAtualizarProcessoJudicial = () => {
  const onSuccess = (response: any) => {
    toast.success("Registro editado(a) com sucesso.");
    queryClient.invalidateQueries(["processo-judicial-edicao-visualizacao"]);
    return response;
  };

  return usePut<ProcessosJudiciaisDTO>({
    url: api.processosJudiciais.putAtualizarDetalhesProcessoJudicial,
    onSuccess,
  });
};
